import { render } from "./AppDetails.vue?vue&type=template&id=3ebf02a1&scoped=true&ts=true"
import script from "./AppDetails.vue?vue&type=script&lang=ts"
export * from "./AppDetails.vue?vue&type=script&lang=ts"

import "./AppDetails.vue?vue&type=style&index=0&id=3ebf02a1&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebf02a1"]])

export default __exports__